(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-article-standard"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE_QUERY = '(max-width: 767.98px)';

  function initMobileBodyReadMore(split) {
    var scroll = split.querySelector('[data-blog-article-body-scroll]');
    var toggle = split.querySelector('[data-blog-article-read-toggle]');
    if (!scroll || !toggle) return;

    var collapsedMax = 360;
    var labelMore = toggle.getAttribute('data-label-more') || 'Read more';
    var labelLess = toggle.getAttribute('data-label-less') || 'Show less';

    function resetReadMore() {
      scroll.classList.remove('is-collapsed-mobile', 'is-expanded-mobile');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = labelMore;
    }

    function setupReadMore() {
      resetReadMore();
      if (window.matchMedia(MOBILE_QUERY).matches && scroll.scrollHeight > collapsedMax) {
        scroll.classList.add('is-collapsed-mobile');
        toggle.hidden = false;
      }
    }

    toggle.addEventListener('click', function () {
      var expanded = scroll.classList.toggle('is-expanded-mobile');
      scroll.classList.toggle('is-collapsed-mobile', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? labelLess : labelMore;
    });

    setupReadMore();
    window.addEventListener('resize', setupReadMore);
  }

  function syncBlogArticleBodyScroll(split) {
    var media = split.querySelector('[data-blog-article-media]');
    var scroll = split.querySelector('[data-blog-article-body-scroll]');
    if (!scroll) return;

    if (window.matchMedia(MOBILE_QUERY).matches || !media) {
      scroll.style.maxHeight = '';
      return;
    }

    scroll.style.maxHeight = media.offsetHeight + 'px';
  }

  function initBlogArticleStandardScroll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-blog-article-split]').forEach(function (split) {
      if (split.dataset.blogArticleScrollInit === 'true') return;
      split.dataset.blogArticleScrollInit = 'true';

      var media = split.querySelector('[data-blog-article-media]');
      var sync = function () {
        syncBlogArticleBodyScroll(split);
      };

      sync();
      initMobileBodyReadMore(split);

      if (media && 'ResizeObserver' in window) {
        var observer = new ResizeObserver(sync);
        observer.observe(media);
      }

      window.addEventListener('resize', sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBlogArticleStandardScroll();
    });
  } else {
    initBlogArticleStandardScroll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBlogArticleStandardScroll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {

  function setupRelatedProductsCarouselNav(sectionEl) {
    if (!sectionEl || !sectionEl.classList || !sectionEl.classList.contains('related-products--desktop-carousel')) return;
    if (!sectionEl.querySelector('.slider-nav--floating .slider-nav__btn')) return;

    if (sectionEl._relatedCarouselNavResizeObserver) {
      try { sectionEl._relatedCarouselNavResizeObserver.disconnect(); } catch (e) { /* noop */ }
      sectionEl._relatedCarouselNavResizeObserver = null;
    }
    if (sectionEl._relatedCarouselNavIo) {
      try { sectionEl._relatedCarouselNavIo.disconnect(); } catch (e) { /* noop */ }
      sectionEl._relatedCarouselNavIo = null;
    }

    function alignSliderArrows() {
      var sliderNav = sectionEl.querySelector('.related-collection--desktop .slider-nav--floating');
      var navBtns = sectionEl.querySelectorAll('.related-collection--desktop .slider-nav--floating .slider-nav__btn');
      var firstImageCont = sectionEl.querySelector('.related-collection--desktop .slider__item .image-cont');
      if (!sliderNav || !navBtns.length || !firstImageCont || !firstImageCont.offsetHeight) return;
      var navRect = sliderNav.getBoundingClientRect();
      var imgRect = firstImageCont.getBoundingClientRect();
      var imageCenterY = imgRect.top + imgRect.height / 2 - navRect.top;
      navBtns.forEach(function(btn) {
        btn.style.top = Math.max(0, imageCenterY) + 'px';
      });
    }

    requestAnimationFrame(alignSliderArrows);

    if (typeof ResizeObserver !== 'undefined') {
      sectionEl._relatedCarouselNavResizeObserver = new ResizeObserver(function() {
        requestAnimationFrame(alignSliderArrows);
      });
      sectionEl._relatedCarouselNavResizeObserver.observe(sectionEl);
    }

    if ('IntersectionObserver' in window) {
      sectionEl._relatedCarouselNavIo = new IntersectionObserver(function(entries) {
        if (entries[0] && entries[0].isIntersecting) {
          requestAnimationFrame(alignSliderArrows);
        }
      });
      sectionEl._relatedCarouselNavIo.observe(sectionEl);
    }
  }

  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector('.related-products');
    if (productRecommendationsSection === null) return;

    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        var nextRoot = container.querySelector('.related-products');
        if (!nextRoot) return;
        productRecommendationsSection.innerHTML = nextRoot.innerHTML;
        productRecommendationsSection.querySelectorAll('carousel-slider').forEach(function(el) {
          if (typeof el.refresh === 'function') el.refresh();
        });
        setupRelatedProductsCarouselNav(productRecommendationsSection);
      }
    };
    request.send();
  };

  document.addEventListener('shopify:section:load', function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });

  function initRelatedProductsSection() {
    var el = document.querySelector('.related-products');
    if (el) setupRelatedProductsCarouselNav(el);
    loadProductRecommendationsIntoSection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProductsSection);
  } else {
    initRelatedProductsSection();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
